import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { array, countryIs, field, personalInfo, REQUIRED } from "./utils";
import * as PANAMA from "../../onboarding/profile-info/form/pa/constants.pa";

const dependentFirstName = field({
  type: FieldTypes.text,
  name: "firstName",
  label: "First Name",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PA"),
  },
  value: () => "",
});

const dependentLastName = field({
  type: FieldTypes.text,
  name: "lastName",
  label: "Last Name",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PA"),
  },
  value: () => "",
});

const dependentType = field({
  type: FieldTypes.select,
  name: "dependentType",
  label: "Dependent Type",
  placeholder: "Select dependent type",
  options: PANAMA.DEPENDENT_TYPE_OPTIONS,
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PA"),
  },
  value: () => "",
});

export const panamaFields = {
  paCedula: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paCedula",
    label: "Cédula (Cedula)",
    validations: {
      required: {
        when: {
          nationality: (value) => value === "PA",
        },
      },
    },
    hideWhen: {
      nationality: (value) => value !== "PA",
    },
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paCedula", ""),
  }),
  paPassport: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paPassport",
    label: "Passport Number",
    validations: {
      required: {
        when: {
          nationality: (value) => value !== "PA",
        },
      },
    },
    hideWhen: {
      nationality: (value) => value === "PA",
    },
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paPassport", ""),
  }),
  paCivilStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paCivilStatus",
    label: "Civil Status",
    placeholder: "Select civil status",
    options: PANAMA.CIVIL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paCivilStatus", ""),
  }),
  paGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paGender",
    label: "Gender",
    placeholder: "Select gender",
    options: PANAMA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paGender", ""),
  }),
  paEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "paEducationLevel",
    label: "Education Level",
    placeholder: "Select education level",
    options: PANAMA.EDUCATION_LEVEL_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paEducationLevel", ""),
  }),
  paSocialInsuranceNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "paSocialInsuranceNumber",
    label: "Social Insurance Number",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PA"),
    },
    value: personalInfo("paSocialInsuranceNumber", ""),
  }),
  paDependentInformation: array({
    type: FieldTypes.object,
    informationType: "family",
    array: {
      limit: 10,
      deletionStrategy: "any",
      itemLabelSuffix: "Dependent",
      showFirstItem: false,
    },
    fields: [dependentFirstName, dependentLastName, dependentType],
    name: "paDependentInformation",
    label: "Dependents",
    scenarios: {
      onboarding: countryIs("PA"),
    },
    serialize: (value) => {
      return value;
    },
    value: (profile) => profile.personalInfo?.paDependentInformation ?? [],
  }),
};
